/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import AuthenticationPasswordForm from 'src/shared/app/authentication/component/base/AuthenticationPasswordForm';
import LazyLoginMain from 'src/shared/app/authentication/component/login/LazyLoginMain';
import messages from 'src/shared/app/authentication/l10n/resetPasswordL10n';
import useEventBraindateName from 'src/shared/domain/event/hook/useEventBraindateName';

type Props = {
  handleSubmit: () => void,
  // Self passed
  intl: intlShape,
};

const ResetPasswordFormDumb = ({ handleSubmit, intl }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const { braindatePlatform: platform } = useEventBraindateName();

  /*
   |----------------------------------------------------------------------------
   | Effects
   |----------------------------------------------------------------------------
   */

  React.useEffect(() => {
    LazyLoginMain.preload();
  }, []);

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <AuthenticationPasswordForm
      legend={intl.formatMessage(messages.legend, {
        platform,
      })}
      label={intl.formatMessage(messages.newPassword)}
      submitCta={intl.formatMessage(messages.submit)}
      handleSubmit={handleSubmit}
    />
  );
};

export default compose(React.memo, injectIntl)(ResetPasswordFormDumb);
